module.exports = __webpack_public_path__ + "img/orange_028.512720bb.png";